import { combineReducers } from 'redux'
import reports from './reports'
import reportDownload from './reportDownload'
import orders from './orders'

export default combineReducers({
  reports,
  reportDownload,
  orders,
})
